/**
 * Widget for the notifications that can show a clickable link.  Specifies the error template and allows
 * clicking a link to get error details.
 *
 * Relies on the content being passed having a message field to display in the Notification.
 *
 * A link with static text here will be appended to the message.
 * The link will be a link to the error details.
 *
 * Created by rdiehl on 2/24/2015.
 */
import locale from "common/managers/locale";
import topic from "common/managers/topic";
import userSettings from "common/managers/userSettings";
import UserSettingNames from "common/enums/settings/UserSettingNames";
import classes from "common/css/widgets/DFErrorNotification.module.less";
import {iconHTML} from "app/widgets/Message/messageUtil";

var DFErrorNotification = kendo.ui.Notification.extend({

    options: {
        name: "DFErrorNotification"
    },

    /**
     * Mapping of error details.
     * Key into the map is the uid passed to the show method
     * Details include:
     * columns: columns to be displayed in the grid, along with the failure messages
     * items: data items that were passed to the call that errored; used to display additional
     *        data about the erroring objects, along with the failure messages from the server.
     * failures: array of errors returned from the server, in the partial or full error object
     */
    errorDetails: {},

    mainClass: `flexRow k-notification-wrap no-icon ${classes.notification}`,

    init: function(element, options) {

        var opts = options;
        opts = $.extend({}, options, {
            templates: [{
                type: 'error',
                template: $.proxy(this._errorTemplate, this)
            }, {
                type: 'warning',
                template: $.proxy(this._warningTemplate, this)
            }, {
                type: "info",
                template: $.proxy(this._tipTemplate, this)
            }, {
                type: "success",
                template: $.proxy(this._successTemplate, this)
            }]
        });
        kendo.ui.Notification.fn.init.call(this, element, opts);

        this.bind("show", $.proxy(this.onShow, this));
        this.bind("hide", $.proxy(this.onHide, this));
    },

    _successTemplate(data) {
        return `<div class="${this.mainClass}">${iconHTML("success")}<div class="k-notification-content">${data.content}</div></div>`;
    },

    _tipTemplate: function(data) {
        var str = `<div class="${this.mainClass}">`;
        str += iconHTML("info");
        str += data.message;
        if (data.hotkey) {
            str += " <a class='viewHotKeyRef'>" + locale.get("open.hotkeyReference") + "</a>";
        }
        str += "</div>";
        return str;
    },

    _detailTemplate(additionalClass, type, data) {
        let str = '';
        if (data.uid) {
            str += `<div class="${this.mainClass} ${additionalClass}" data-uid=${data.uid}>`;
        } else {
            str += `<div class="${this.mainClass} ${additionalClass}"`;
        }
        str += iconHTML(type);
        str += '<div class="k-notification-content">';
        if (data.message) {
            str += `<span>${data.message}</span>`;
        }
        if (data.hasErrors) {
            str += `<a class=${classes.viewErrors}>${locale.get("error.partial.append")}</a>`;
        }
        str += '</div>';
        str += `<span class="${classes.closeIcon}" title="${locale.get("hide")}"></span></div>`;
        return str;
    },

    _warningTemplate: function(data) {
        return this._detailTemplate(classes.warning, "warning", data);
    },

    _errorTemplate: function(data) {
        return this._detailTemplate(classes.error, "error", data);
    },

    viewErrors: function(e) {
        var uid = $(e.currentTarget).closest("div.k-notification-wrap").attr("data-uid");
        e.preventDefault();
        e.stopPropagation();
        this.trigger("viewErrors", this.errorDetails[uid]);
    },

    show: function(content, type, obj) {
        if (type === "warning" || type === "error") {
            this.setOptions({
                autoHideAfter: userSettings.getInt(UserSettingNames.NOTIFICATIONS_ERROR_HIDE, 30000)
            });
        } else {
            this.setOptions({
                autoHideAfter: userSettings.getInt(UserSettingNames.NOTIFICATIONS_SUCCESS_HIDE, 5000)
            });
        }

        kendo.ui.Notification.fn.show.apply(this, arguments);
        if (content.uid) {
            this.errorDetails[content.uid] = obj;
        }
    },

    onShow: function(e) {
        if (e && e.element) {
            e.element.find(`a.${classes.viewErrors}`).on("click", $.proxy(this.viewErrors, this));
            e.element.find("a.viewHotKeyRef").on("click", this.showHotKeyRef);
        }
    },

    showHotKeyRef: function() {
        topic.publish("app/hotkeyref");
    },

    onHide: function(e) {
        if (e) {
            if (e.currentTarget) {
                var uid = $(e.currentTarget).closest("div.k-notification-wrap").attr("data-uid");
                delete this.errorDetails[uid];
            }
            if (e.element) {
                e.element.find("a").off();
            }
        }
    }

});

kendo.ui.plugin(DFErrorNotification);
export default DFErrorNotification;
